import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import type { Me } from '@pen/shared';
import { api, ApiRequestError } from '../api';

interface Session { user: Me | null; loading: boolean; error: string | null; refresh(): Promise<void>; setUser(user: Me | null): void }
const Context = createContext<Session | null>(null);
export function SessionProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  async function refresh() {
    try { setUser(await api.me()); setError(null); }
    catch (reason) { setUser(null); if (!(reason instanceof ApiRequestError && reason.status === 401)) setError(reason instanceof Error ? reason.message : 'Could not reach the studio.'); }
    finally { setLoading(false); }
  }
  useEffect(() => {
    void refresh();
    const logout = () => setUser(null);
    window.addEventListener('pen:unauthenticated', logout);
    return () => window.removeEventListener('pen:unauthenticated', logout);
  }, []);
  return <Context.Provider value={{ user, loading, error, refresh, setUser }}>{children}</Context.Provider>;
}
export function useSession(): Session {
  const context = useContext(Context);
  if (!context) throw new Error('SessionProvider is required');
  return context;
}
